import { CheckCircle2, Printer } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Receipt } from "@/components/Receipt";
import { buildReceiptModel } from "@/lib/receipt";
import { formatMoney } from "@/lib/money";
import { usePrint } from "@/context/PrintContext";

export function SaleCompleteDialog({ sale, biz, onClose }) {
  const { printSale } = usePrint();
  if (!sale) return null;
  const m = (n) => formatMoney(n, sale.decimals);
  return (
    <Dialog open={!!sale} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-h-[92dvh] max-w-md overflow-y-auto" data-testid="sale-complete-dialog">
        <DialogHeader>
          <div className="flex items-center gap-2 text-emerald-600"><CheckCircle2 className="h-5 w-5" /><span className="eyebrow !text-emerald-700">Sale completed</span></div>
          <DialogTitle className="font-display text-2xl" data-testid="sale-complete-receipt-no">Receipt {sale.receipt_code}</DialogTitle>
          <DialogDescription className="sr-only">Sale summary</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-2">
          <div className="rounded-xl bg-slate-950 p-3 text-white">
            <div className="eyebrow !text-slate-400">Total · {sale.payment.method}</div>
            <div className="money mt-1 text-xl font-extrabold" data-testid="sale-complete-total">{sale.currency} {m(sale.totals.total)}</div>
          </div>
          <div className="rounded-xl bg-emerald-50 p-3">
            <div className="eyebrow !text-emerald-700">Change</div>
            <div className="money mt-1 text-xl font-extrabold text-emerald-800" data-testid="sale-complete-change">{m(sale.payment.change)}</div>
          </div>
        </div>
        <div className="max-h-[38dvh] overflow-y-auto rounded-xl border border-slate-200 bg-white py-3">
          <Receipt model={buildReceiptModel(sale, biz)} />
        </div>
        <div className="flex gap-2">
          <button onClick={() => printSale(sale)} data-testid="print-receipt-button" className="flex h-12 flex-1 items-center justify-center gap-2 rounded-xl border-2 border-slate-900 font-semibold text-slate-900 hover:bg-slate-50">
            <Printer className="h-4 w-4" /> Print receipt
          </button>
          <button autoFocus onClick={onClose} data-testid="new-sale-button" className="h-12 flex-1 rounded-xl bg-amber-500 font-semibold text-slate-950 hover:bg-amber-400">
            New sale
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
